import { useTranslations } from '@vocab/react';
import { Bleed, Drawer } from 'braid-design-system';

import translations from '../.vocab';
import { CareerFeedAIHeading } from '../CareerFeedAIHeading';

interface CareerFeedDesktopDrawerProps {
  children: React.ReactNode;
  shouldOpen?: boolean;
  onClose?: () => void;
}

const CareerFeedDesktopDrawer = ({
  children,
  shouldOpen = false,
  onClose = () => {},
}: CareerFeedDesktopDrawerProps) => {
  const { t } = useTranslations(translations);

  return (
    <Drawer
      title=""
      width="small"
      onClose={onClose}
      open={shouldOpen}
      id="career-feed-desktop-drawer"
    >
      <Bleed top="large">
        <CareerFeedAIHeading
          headingText={t('Define your preferences')}
          adjacent
        />
      </Bleed>
      {children}
    </Drawer>
  );
};

export default CareerFeedDesktopDrawer;
